import { MaterialGroup } from '@cutr/constants/cutlist';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { api } from '@/api/backend';
import { setGroupAndParts, useMaterialGroupState } from '@/api/materialsGroup';
import { useCutlistState } from '@/api/store';
import SelectMaterialModal from '@/interfaces/PartTableCommon/SelectMaterialModal';

import styles from './EmptyMultiProductCutlist.module.css';

export const EmptyMultiProductCutlist = () => {
  const { t } = useTranslation();
  const [sheetMaterialsModalOpen, setSheetMaterialsModalOpen] = useState(false);
  const { addPart } = useCutlistState();

  const groups = useMaterialGroupState((state) => state.groups);
  const { addGroup, removeEmptyGroups, setGroup } = useMaterialGroupState();

  const onOpenSheetMaterialsModal = () => {
    if (!groups.length) {
      addGroup();
    }
    setSheetMaterialsModalOpen(true);
  };
  const onCloseSheetMaterialsModal = () => {
    // clean up empty groups
    removeEmptyGroups();
    setSheetMaterialsModalOpen(false);
  };

  const onSelectSheetMaterial = (selection: Partial<MaterialGroup>) => {
    window.analytics.track('Cutlist Material Group Added');

    setGroup({ ...groups[0], ...selection });

    if (groups[0]) {
      addPart(groups[0]);
    }

    removeEmptyGroups();
  };

  const onSelectBeamMaterial = async () => {
    window.analytics.track('Cutlist Beams Group Added');

    const groupId = addGroup({ type: 'beams' });

    const newGroup = useMaterialGroupState
      .getState()
      .groups.find((g) => g.id === groupId);

    let beamMaterials = [];
    try {
      beamMaterials = (await api.beamMaterials({ limit: 1 })) || [];
    } catch (error) {
      toast.error(t('new-cutlist-order.beamsLoadingError'));
      console.error('Failed to load beam materials:', error);
    }

    if (newGroup) {
      addPart(newGroup, 'beam');
      if (beamMaterials.length > 0) {
        const firstMaterial = beamMaterials[0];
        setGroupAndParts({
          ...newGroup,
          name: firstMaterial.variationGroup?.name || firstMaterial.name,
          beamMaterialId: firstMaterial.id,
        });
      }
    }

    removeEmptyGroups();
  };

  return (
    <div className={'content'}>
      <div className={styles.container}>
        <h1>{t('cutlist-form.newCutlistOrder')}</h1>
        <div className={classNames('flexAlign gap-m', styles.productCards)}>
          <div
            className={styles.productCard}
            onClick={onOpenSheetMaterialsModal}
          >
            <img src="/sheet-materials.png" alt="Sheet Materials" />
            <div className={styles.productTitle}>
              {t('new-cutlist-order.sheetMaterials')}
            </div>
            <p>{t('new-cutlist-order.sheetMaterialsDescription')}</p>
          </div>
          <div className={styles.productCard} onClick={onSelectBeamMaterial}>
            <img src="/soft-wood-beams.png" alt="Softwood Beams" />
            <div className={styles.productTitle}>
              {t('new-cutlist-order.softwoodBeams')}
            </div>
            <p>{t('new-cutlist-order.softwoodBeamsDescription')}</p>
          </div>
        </div>
      </div>
      {groups.length > 0 && (
        <SelectMaterialModal
          field={'core1'}
          group={groups[0]}
          onUpdateMaterial={onSelectSheetMaterial}
          isOpen={sheetMaterialsModalOpen}
          handleClose={onCloseSheetMaterialsModal}
        />
      )}
    </div>
  );
};
